
export const trialFeaturesSelector = (store) => store.sharedMailbox.trialAddon.data;
export const loadingTrialDataSelector = (store) => store.sharedMailbox.loadingTrialData;